import moment from 'moment';


/**
 * [getHighlightsAndMarkers description]
 * @return {Object} data     [highlight & marker key/value]
 */
function getHighlightsAndMarkers() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.getHighlights(res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API getHighlightsAndMarkers: ${code} ${status} ${message}`);
      }

      resolve(data);
    });
  });
}

/**
 * [createHighlight description]
 * @param  {String} options.markerId  [VS globalId of marker]
 * @return {Object}                   [highlight data]
 */
function createHighlight({ markerId, noteText }) {
  const start = moment(new Date().getTime());
  const options = {
    markerId,
    noteText
  };

  logger.info('CREATE_HIGHLIGHT', { refId: window._ref_id, options });

  return new Promise((resolve, reject) => {
    window.vsViewer.Book.highlightCurrentSelection(options, res => {
      const LAG = moment(new Date().getTime()).diff(start, 'seconds', true);
      const { code, data, message, status } = res;

      if (code !== 200) {
        logger.error('CREATE_HIGHLIGHT--failed', { refId: window._ref_id, LAG, code, status, message });
        console.error(`API createHighlight: ${code} ${status} ${message}`);
      }

      logger.info('CREATE_HIGHLIGHT--success', { refId: window._ref_id, LAG, code, status, message });
      resolve({
        highlight: data && data.highlight ? data.highlight : null,
        code,
        message
      });
    });
  });
}

/**
 * [updateHighlight description]
 * @param  {String} highlightId      [VS syncId]
 * @param  {String} options.markerId [VS globalId]
 * @param  {String} options.noteText [User input]
 * @return {Object}                  [highlight data]
 */
function updateHighlight(highlightId, markerId, noteText) {
  const start = moment(new Date().getTime());
  const options = {
    markerId,
    noteText
  };

  logger.info('UPDATE_HIGHLIGHT', { refId: window._ref_id, highlightId, options });

  return new Promise((resolve, rejects) => {
    window.vsViewer.Book.updateHighlight(highlightId, options, res => {
      const LAG = moment(new Date().getTime()).diff(start, 'seconds', true);
      const { code, data, message, status } = res;

      if (code !== 200) {
        logger.error('UPDATE_HIGHLIGHT--failed', { refId: window._ref_id, LAG, code, status, message });
        console.error(`API updateHighlight: ${code} ${status} ${message}`);
      }

      logger.info('UPDATE_HIGHLIGHT--success', { refId: window._ref_id, LAG, code, status, message });
      resolve({
        highlight: data && data.highlight ? data.highlight : null,
        code,
        message
      });
    });
  });
}

/**
 * [deleteHighlight description]
 * @param  {String} highlightId   [VS syncId]
 * @return {Object}               [Code & message]
 */
function deleteHighlight(highlightId) {
  const start = moment(new Date().getTime());
  logger.info('DELETE_HIGHLIGHT', { refId: window._ref_id, highlightId });

  return new Promise((resolve, reject) => {
    window.vsViewer.Book.deleteHighlight(highlightId, res => {
      const LAG = moment(new Date().getTime()).diff(start, 'seconds', true);
      const { code, data, message, status } = res;

      if (code !== 200) {
        logger.error('DELETE_HIGHLIGHT--failed', { refId: window._ref_id, LAG, code, status, message });
        return;
      }

      logger.info('DELETE_HIGHLIGHT--success', { refId: window._ref_id, LAG, code, status, message });
      resolve({ code, message });
    });
  });
}

/**
 * [getMarkers description]
 * @return {Object} [markers]
 */
function getMarkers() {
  return new Promise((resolve, reject) => {
    Jigsaw.User.getMarkers(res =>{
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API getMarkers not ok: ${code} ${status} ${message}`);
      }

      resolve({ code, markers: data.markers, message });
    });
  });
}

/**
 * [getPageBreaks description]
 * @return {Object} [pagelist]
 */
function getPageBreaks() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.getPageBreaks(res =>{
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API getPageBreaks not ok: ${code} ${status} ${message}`);
      }

      resolve({ code, pageBreaks: data.pagelist, message });
    });
  });
}
/**
 * [createMarker description]
 * @param  {String} options.color       [vstColor]
 * @param  {String} options.friendsOnly [sharing option]
 * @param  {String} options.label       [marker label]
 * @param  {String} options.shared      [sharing option]
 * @return {String}                     [code, data, message]
 */
function createMarker({ color, friendsOnly, label, shared }) {
  const marker = {
    color,
    friendsOnly,
    label,
    shared
  };

  return new Promise((resolve, reject) => {
    Jigsaw.User.createMarker(marker, res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API getMarkers not ok: ${code} ${status} ${message}`);
      }

      resolve({ code, data, message });
    });
  });
}

/**
 * [deleteMarker description]
 * @param  {String} markerId [VS globalId that identifies specific marker reference]
 * @return {Object}          [code, markerId, message]
 */
function deleteMarker(markerId) {
  return new Promise((resolve, reject) => {
    Jigsaw.User.deleteMarker(markerId, res => {
      const { code, message, status } = res;

      if (code !== 200) {
        console.warn(`API deleteMarker: ${code} ${status} ${message}`);
      }

      resolve({ code, markerId, message });
    });
  });
}

/**
 * [getBookmarks description]
 * @return {Array}           [Array of objects]
 */
function getBookmarks() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.getBookmarks(res =>{
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API getBookmarks not ok: ${code} ${status} ${message}`);
      }

      resolve({ bookmarks: data.bookmarks });
    });
  });
}

/**
 * [getTOC description]
 * @return {Array}           [Array of objects]
 */
function getTOC() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.getTOC(res =>{
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API getTOC not ok: ${code} ${status} ${message}`);
      }

      resolve({ toc: data.toc });
    });
  });
}


/**
 * [createBookmark description]
 * @param  {[type]} options.currentCfi  [CFI from scroll event]
 * @param  {[type]} options.currentPage [Page from page break]
 * @return {[type]}                     [vs bookmark]
 */
function createBookmark() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.setBookmark(res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API createBookmark: ${code} ${status} ${message}`);
      }

      resolve({ bookmark: data.bookmark, code, message });
    });
  });
}

/**
 * [deleteBookmark description]
 * @param  {String} guid     [VS id that identifies unique bookmarks]
 * @return {Object}          [code, data, message]
 */
function deleteBookmark(guid) {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.deleteBookmark(guid, res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API deleteBookmark: ${code} ${status} ${message}`);
      }

      resolve({ code, data, message });
    });
  });
}

/**
 * [goToCFI description]
 * @param  {String} cfi      [ebook CFI]
 * @return {Object} data     [code, data, message]
 */
function goToCFI(cfi) {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.goToCFI(cfi, res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API goToCFI: ${code} ${status} ${message}`);
        debugger;
      }

      resolve({ code, data, message });
    });
  });
}

function goToPageNumber(label) {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.goToPage(label, res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API goToPageNumber: ${code} ${status} ${message}`);
        reject();
      }

      resolve({ code, data, message });
    });
  });
}

/**
 * [goToPreviousPage description]
 * @return {[type]} [description]
 */
function goToPreviousPage() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.goToPreviousPage(res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API goToCFI: ${code} ${status} ${message}`);
        debugger;
      }

      resolve({ code, data, message });
    });
  });
}

/**
 * [goToNextPage description]
 * @return {[type]} [description]
 */
function goToNextPage() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.goToNextPage(res => {
      const { code, data, message, status } = res;

      if (code !== 200) {
        console.error(`API goToCFI: ${code} ${status} ${message}`);
        debugger;
      }

      resolve({ code, data, message });
    });
  });
}

/**
 * [getNextPageInfo description]
 * @return {[type]} [description]
 */
function getNextPageInfo() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.getNextPage(res => {
      const { code, data, message, status } = res;

      if (code === 500) {
        return resolve({ code, data, message });
      }

      if (code !== 200) {
        console.error(`API getNextPageInfo: ${code} ${status} ${message}`);
        return resolve({ code, data: {}, message });
      }

      resolve({ code, data, message });
    });
  });
}

/**
 * [getPreviousPageInfo description]
 * @return {[type]} [description]
 */
function getPreviousPageInfo() {
  return new Promise((resolve, reject) => {
    window.vsViewer.Book.getPreviousPage(res => {
      const { code, data, message, status } = res;

      if (code === 500) {
        return resolve({ code, data, message });
      }

      if (code !== 200) {
        console.error(`API getPreviousPage: ${code} ${status} ${message}`);
        return resolve({ code, data: {}, message });
      }

      resolve({ code, data, message });
    });
  });
}



export {
  createBookmark,
  createHighlight,
  createMarker,
  deleteBookmark,
  deleteHighlight,
  deleteMarker,
  getBookmarks,
  getTOC,
  getHighlightsAndMarkers,
  getMarkers,
  getNextPageInfo,
  getPreviousPageInfo,
  goToCFI,
  goToNextPage,
  goToPreviousPage,
  goToPageNumber,
  getPageBreaks,
  updateHighlight
};
